import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { IntlProvider, Text, Localizer, withText } from 'preact-i18n';
import util from 'preact-util';
import { animalAge } from '../../lib/animalAge';

class MiniAnimal extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentDidUpdate() {
    }

    render() {
        const { animals = [] } = this.props;
        if (!animals.length) {
            return null;
        }
        return (<div class='w-100 d-flex justify-content-center position-relative'>
            <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                {animals?.map(animal => {
                    const a = { ...animal };
                    return (
                        <div className='d-flex flex-column' key={a.id}>
                            <div class='d-flex flex-row mb-1'>
                                <strong>{a.name}</strong> {a.birth && <span class='ms-2'>({animalAge(a.birth)})</span>}
                                {a.species && <span class='ms-2 text-muted'>{a.species}</span>}
                                {a.breed && <span class='ms-1 text-muted'>/ {a.breed}</span>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>);
    }
}

export default MiniAnimal;